import Button from "../Button";
import Container from "../Container";
import {useRouter} from "next/router";

export default function SectionRegisterCta({children, href = '/register', cta = 'Registrovat se'}) {
    const {locale} = useRouter();

    return (
        <Container>
            <div className="text-center flex flex-col items-center gap-8 md:gap-10 accent-red-800">
                <header>
                    {children}
                </header>


                <div className="w-full">
                    <Button href={href} className="w-full min-w-[260px] max-w-max">{cta}</Button>
                </div>
            </div>
        </Container>
    )
}